import { REVIEW_ENTRY_STATUSES } from '@/lib/constants/reviewEntries'

export const REVIEW_ENTRIES = {
  NEVER: 'Nunca',
  SAVE: 'Guardar',
  CANCEL: 'Cancelar',
  DATE: 'Fecha',
  PERFORMED_BY: 'Realizado por',
  NOTES: 'Notas',
  STATUS: 'Estado',
  STATUSES: {
    [REVIEW_ENTRY_STATUSES.SUCCESS]: 'Correcto',
    [REVIEW_ENTRY_STATUSES.WARNING]: 'Con advertencias',
    [REVIEW_ENTRY_STATUSES.FAILED]: 'Fallido',
  },
  SAVED: 'Entrada registrada',
  ATTACH_FILE: 'Adjuntar archivo',
  REMOVE_FILE: 'Quitar archivo',
  OPEN_FILE_FAILED: 'No se pudo abrir el archivo',
  REVIEW: {
    LABEL: 'Última revisión',
    HISTORY: 'Historial de revisiones',
    COUNT: (count: number) => (count === 1 ? '1 revisión' : `${count} revisiones`),
    LOG: 'Registrar una revisión',
    EMPTY: 'Sin revisiones registradas',
  },
  MAINTENANCE: {
    LABEL: 'Último mantenimiento',
    HISTORY: 'Historial de mantenimiento',
    COUNT: (count: number) => (count === 1 ? '1 entrada' : `${count} entradas`),
    LOG: 'Registrar un mantenimiento',
    EMPTY: 'Sin mantenimientos registrados',
  },
}
